import { Component, EventEmitter, Output, OnInit, OnDestroy, HostListener } from '@angular/core';
import { NavbarSectionEnum, NavigationService, NavSection, NavSectionChildren } from './services/navigation.service';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { firstValueFrom, pipe, Subscription, take } from 'rxjs';
import { MyAccountService } from 'src/app/pages/my-account/services/my-acount.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LocalStorageKeys } from 'src/app/core/enums/LocalStorageKeys';


const WorkshopAccessUserIds: string[] = [
  'db132827-94f7-4845-ac9b-fcdbacbbd083'  // Porche
]

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {

  isHovered = false; // Controla el hover
  isClickBlocked = false; // Bloquea el hover tras el click
  isCollapsed = false;
  @Output() isCollapsedEvent = new EventEmitter<boolean>(false);

  sections: NavSection[] = [];
  accountSections: NavSection[] = [];

  userName = 'Test User';
  userEmail = 'test@gmail.com';
  userImg = '../../assets/icons/navbar/nav-user-icon.svg';
  localAccountId: string = "";

  private userSubscription!: Subscription;

  constructor(
    private navService: NavigationService,
    private userService: UserService,
    private router: Router,
    private MyAccountService: MyAccountService,
    private LocalStorageService: LocalStorageService
  ) {

  }

  async ngOnInit() {
    this.isCollapsed = !!this.LocalStorageService.get(LocalStorageKeys.IsNavbarCollapsed)

    this.initialData();
  }

  async initialData() {
    this.sections = await this.navService.getSections();
    this.accountSections = this.navService.getAccountSections();
    this.userSubscription = this.userService.getUserInfo().subscribe((user) => {
      if (user) {
        this.userName = user.name;
        this.userEmail = user.email;
        this.userImg = user.img;
        this.localAccountId = user.localAccountId;
        this.checkWorkshopReportSection()
      } else {
        this.userName = 'Guest User';
        this.userEmail = 'No Email Provided';
        this.userImg = '../../assets/icons/navbar/nav-user-icon.svg';
      }
    });
  }

  checkWorkshopReportSection(): void {
    if (WorkshopAccessUserIds.includes(this.localAccountId) && !this.checkWorkshopReportSectionExist()) {
      let WorkshopRepport = this.navService.getWorkshopReport();
      this.sections.map((x: NavSection) => {
        if (x.id == NavbarSectionEnum.EXPENSES_CONTROL) {
          x.children.push(WorkshopRepport);
        }
        return x;
      })
    }
  }

  checkWorkshopReportSectionExist(): boolean {
    return this.sections.some((x: NavSection) => {
      return x.children.some((y: NavSectionChildren) => {
        return y.path == "workshop-report";
      })
    })
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event: any) {
  //   this.checkScreenSize();
  // }

  // checkScreenSize() {
  //   if (window.innerWidth <= 1255) {
  //     this.isCollapsed = true;
  //   } else {
  //     this.isCollapsed = false;
  //   }
  //   this.isCollapsedEvent.emit(this.isCollapsed);
  // }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapsedEvent.emit(this.isCollapsed);
  }

  showNavigation() {
    if (!this.isClickBlocked) {
      this.isHovered = true;
    }
  }

  hideNavigation() {
    this.isHovered = false;
  }

  resetHoverState() {
    // Bloquea el estado hover brevemente tras el click
    this.isClickBlocked = true;
    setTimeout(() => {
      this.isClickBlocked = false;
    }, 300); // Ajusta el tiempo para coincidir con tu animación CSS
  }

  checkSamePath(subSectionPath: string | undefined): boolean {
    const actualPath = this.router.url;
    const segments = actualPath.split('/');
    const lastSegment = segments[segments.length - 1];
    return lastSegment === subSectionPath;
  }

  clearSummaryData() {
    this.LocalStorageService.removeArray([LocalStorageKeys.SummaryData, LocalStorageKeys.ReturnTransferSummaryData])
  }
}
